import type { ReactNode } from 'react';
import { marcarAcronimosNodes } from './acronimos';

/**
 * Resalta @menciones en texto plano con el chip del app (.msg-mention, acento morado) y
 * convierte **negritas** de los mensajes del sistema. UN solo helper para TODAS las pantallas:
 * antes Messaging e InspectorMessages tenían cada uno su copia y el resto (Case Overview,
 * notas internas, scheduling) no resaltaba nada (pedido de David).
 */
export function renderMentions(text: string, keyBase = 'm'): ReactNode[] {
  return text.split(/(\*\*[^*]+\*\*|@\w+)/g).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) return <b key={`${keyBase}-${i}`}>{part.slice(2, -2)}</b>;
    if (part.startsWith('@') && part.length > 1) return <span key={`${keyBase}-${i}`} className="msg-mention">{part}</span>;
    return <span key={`${keyBase}-${i}`}>{marcarAcronimosNodes(part, `${keyBase}-${i}`)}</span>;
  });
}
